import { create } from 'zustand';
import type { NewSignalOverride } from '../data/overridesRuntime';
import { fetchAndApplyOverrides } from '../data/refreshOverrides';

/**
 * signalLifecycleDraft — alta/baja directa de un semáforo (Modo Edición,
 * ARS-05). Guardado real desde 2026-09-10 (antes: export a un snippet que
 * nunca llegaba a pegarse). Sin estado propio — tras cada escritura se
 * vuelve a pedir `GET /api/overrides` completo.
 */
export type { NewSignalOverride } from '../data/overridesRuntime';

interface DraftState {
  saving: boolean;
  /** Genera un ID sintético negativo (nunca colisiona con IDs OSM reales,
   * siempre positivos) y lo guarda directamente. */
  stageAdd: (position: [number, number]) => Promise<boolean>;
  stageRemove: (id: number) => Promise<boolean>;
}

export const useSignalLifecycleDraft = create<DraftState>((set) => ({
  saving: false,
  stageAdd: async (position) => {
    set({ saving: true });
    const id = -Date.now();
    const d: NewSignalOverride = { id, position };
    try {
      const res = await fetch(`/api/overrides/signal_added/${id}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(d),
      });
      if (!res.ok) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
  stageRemove: async (id) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/signal_removed/${id}`, {
        method: 'PUT',
        credentials: 'include',
      });
      if (!res.ok) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
}));
